import './NotificationDialog.scss'
import { Dialog } from 'primereact/dialog'
import Button1 from '../ui/Button1'
import React, { useEffect } from 'react'
import { IRemoteOfficeType } from '../../types/MainType'
import HomeOfficeTypeSelection from './HomeOfficeTypeSelection'
import { useTranslation } from 'react-i18next'
import { InputTextarea } from 'primereact/inputtextarea';


const NotificationDialog = (props: {
  display: boolean
  hasButton?: boolean
  extraButton?: boolean
  goHomeButton?: boolean
  firstButtonLabel?: string
  secondButtonLabel?: string
  content?: string
  title?: string
  imgSrc?: string
  onHide: () => void
  textDate?: string
  selectedType: null | IRemoteOfficeType
  setSelectedType: any
  types: IRemoteOfficeType[] | []
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void
  inputFieldVisible?: boolean // Dinamik görünürlük için
  inputFieldLabel?: string // Dinamik placeholder metni için
  inputValue?: string // Kullanıcının girdiği değeri tutmak için
  onInputChange?: (value: string) => void // Değişiklikleri yönetmek için
  inputError?: boolean
  loading?: boolean
}) => {
  const { t } = useTranslation()
  useEffect(() => {}, [])

  const renderFooter = () => {
    return (
      <div className="row justify-content-center">
        {props.extraButton ? (
          <>
            <div className={'col-6 pe-1 ps-1'}>
              <Button1 class={'button-white-sm'} label={props.secondButtonLabel} onClick={props.onHide} disabled={props.loading} />
            </div>
            <div className={'col-6 pe-1 ps-1'}>
              <Button1 class={'button-blue-sm'} label={props.loading ? '' : props.firstButtonLabel} onClick={props.onSubmit} disabled={props.loading} loading={props.loading} />
            </div>
          </>
        ) : props.hasButton ? (
          <>
            <div className={'col-6 pe-1 ps-1'}>
              <Button1 class={'button-blue-sm'} label={props.firstButtonLabel} onClick={() => props.onHide} />
            </div>
          </>
        ) : (
          props.goHomeButton && (
            <>
              <div className={'col-12 pe-1 ps-1'}>
                <Button1 class={'button-blue-sm'} label={props.loading ? '' : props.firstButtonLabel} onClick={props.onSubmit} disabled={props.loading} loading={props.loading} />
              </div>
            </>
          )
        )}
      </div>
    )
  }

  const contentTemplate = () => {
    return (
      <>
        <div className={'row justify-content-center mb-4'}>
          <img className="not-cal-pic" src={props.imgSrc} alt="icon" />
        </div>
        <div className={'row mb-3'}>
          <span className={'not-cal-head'}>{props.title}</span>
        </div>
        {props.types.length > 0 && (
          <div className="mb-3">
            <HomeOfficeTypeSelection
              selectedType={props.selectedType}
              setSelectedType={props.setSelectedType}
              types={props.types}
            />
          </div>
        )}

        <div className={'row mb-3'}>
          <span className={'not-cal-content'}>{props.content}</span>
        </div>
        {props.textDate && (
          <div className={'row my-3'}>
            <div className={'not-cal-content'}>
              <span className={'not-cal-date'}>{t('input-texts.date')}: </span>
              {props.textDate}
            </div>
          </div>
        )}
        {/* Dinamik olarak gösterilen textbox */}
        {props.inputFieldVisible && (
          <div className="row mb-3">
          <InputTextarea
            className={`not-cal-textbox ${props.inputError ? 'p-invalid' : ''}`}
            placeholder={props.inputFieldLabel}
            value={props.inputValue}
            rows={5}
            cols={30}
            onChange={(e) => props.onInputChange && props.onInputChange(e.target.value)}
          />
          {props.inputError && (
            <small className="p-error">{props.inputFieldLabel || 'Bu alan zorunludur'}</small>
          )}
          </div>
        )}
      </>
    )
  }

  return (
    <div className="notification-modal">
      <Dialog
        blockScroll
        contentClassName={'notification-modal-content'}
        visible={props.display}
        onHide={props.onHide}
        breakpoints={{ '576px': '80vw' }}
        style={{ width: '400px' }}
        footer={renderFooter()}
        draggable={false}
        resizable={false}>
        {contentTemplate()}
      </Dialog>
    </div>
  )
}
export default NotificationDialog
